import script from "./PlansView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlansView.vue?vue&type=script&setup=true&lang=ts"

import "./PlansView.vue?vue&type=style&index=0&id=db9c3926&lang=css"

const __exports__ = script;

export default __exports__